//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FlexButtonGroup from '../flex/FlexButtonGroup';
import FlexRange from '../flex/FlexRange';
import SpriteIcon from '../elements/SpriteIcon';
import {toggleSlide} from '../../helpers/slide';
import Vue from "vue";

export default {
    components: {
        SpriteIcon,
        FlexButtonGroup,
        FlexRange,
    },
    props: {
        lang: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            loading: true,
            cupsByDay: {
                min: 1,
                max: 21,
                step: 1,
            },
            cupsByPerson: {
                1: 'one-cup',
                2: 'two-cups',
                3: 'three-cups',
            },
            packs: [],
            filteredPacks: [],
            selectedPack: 0,
            nbrCupsByDay: 1,
            nbrCupsByMonth: 30,
            type: 'STD',
            nbrPersons: 1,
            nbrCupsPerPerson: 1,
            week: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
            },
            more: false,
        }
    },
    watch: {
        nbrCupsByDay: function (new_value) {
            this.nbrCupsByMonth = new_value * 30;
        },

        nbrCupsByMonth: function (new_value) {
            const index = this.filterPacks().findIndex(pack => {
                return pack.max_volume >= new_value;
            });

            if (this.type === 'STD') {
                this.handleSelectPack(index);
            }
        },

        nbrPersons: function () {
            this.compute();
        },

        nbrCupsPerPerson: function () {
            this.compute();
        },

        week: function () {
            this.compute();
        },
    },
    computed: {
        computedContactEmail: function () {
            return 'mailto:' + this.$options.filters.__('pack.contact_email');
        },
    },
    methods: {
        compute() {
            if (this.week) {
                const nbrDays = Object.keys(this.week).reduce((acc, key) => {
                    return this.week[key] === true ? acc + 1 : acc;
                }, 0);

                const nbrPersons = this.nbrPersons;

                const nbrCupsPerPerson = this.nbrCupsPerPerson;

                this.nbrCupsByDay = nbrPersons * nbrCupsPerPerson;
                this.nbrCupsByMonth = Math.max( 30 * ( Math.ceil(( this.nbrCupsByDay * nbrDays) / 7 ) ), 30 );
            }
        },

        handleSelectPack(index) {
            this.selectedPack = index;

            if (index !== -1) {
                this.type = this.filteredPacks[index].type;
            }
        },

        filterPacks() {
            this.filteredPacks = this.packs.map(pack => {
                const price = pack.pricing.find(price => {
                    return price.volume === this.nbrCupsByMonth;
                });

                if (price !== undefined) {
                    pack.price = price;
                }

                return pack;
            });

            return this.filteredPacks;
        },

        selectPack() {
            this.selectedPack = this.type === 'PRM' ? 1 : 0;
        },

        computeMonthlyPrice(pack) {
            if (pack.price) {
                return pack.price.per_cup_vat_incl * pack.price.volume;
            }

            return 0;
        },

        handleSubmit() {
            const data = {
                nbrPersons: this.nbrPersons,
                nbrCupsPerPerson: this.nbrCupsPerPerson,
                nbrCupsByMonth: this.nbrCupsByMonth,
                week: this.week,
                type: this.type,
            };

            this.$app.get('axios').post('/api/funnel/pack?lang=' + this.lang, data).then(() => {
                this.$forceUpdate();

                window.dataLayer?.push( { 'event': 'step1next' } );

                this.$emit('submit');
            });
        },

        handleHelpButton() {
            window.dataLayer?.push( { 'event': 'step1help' } );

            toggleSlide(this.$refs.helping, 300);

            this.$el.querySelector('.btn-help .sprite-icon').classList.toggle('rotate-90');

            this.$refs.cups_button_group.display();
        },

        handleDayCheck(day, value) {
            this.week[day] = value;

            Vue.nextTick(() => {
                this.compute();
            });
        },

        handleMoreItems() {
            this.more = !this.more;
        }
    },
    created() {
        this.$app.get('axios').get('/api/funnel/packs?lang=' + this.lang ).then( response => {
            this.packs = response.data;

            this.filterPacks();

            this.$app.get('axios').get('/api/funnel/pack?lang=' + this.lang ).then( response => {
                const data = response.data;

                if (data !== false) {
                    this.nbrPersons = data.nbrPersons;
                    this.nbrCupsPerPerson = data.nbrCupsPerPerson;
                    this.week = data.week;
                    this.type = data.type;
                    this.nbrCupsByMonth = data.nbrCupsByMonth;

                    this.selectPack();
                }

                this.loading = false;
            });
        });
    },

    mounted() {
        window.dataLayer?.push( { 'event': 'step1in' } );
    }
}
